import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { useAppSelector } from '@core/hooks/appHooks';
import { selectIsLoading } from '@core/store/appSlice/appSlice';
import { DemmiHooks } from '@subhanhabib/demmilib';

import Logo from '../../assets/demmi-logo.svg';

interface LoadingGlobalProps {
  isLoading?: boolean;
  isMounted?: boolean;
  isLogin?: boolean;
}

const LoadingGlobal: React.FC<LoadingGlobalProps> = ({ isLogin }) => {
  const CSSBlock = 'loading-overlay';
  const isLoading = useAppSelector(selectIsLoading);
  const mountedStyle = { animation: 'globalLoadingIn 100ms ease-in-out 0s' };
  const unmountedStyle = {
    animation: 'globalLoadingOut 400ms ease-in-out 0s',
  };

  const [isMounted, setIsMounted] = useState(false);
  const shouldRenderGlobalLoading = DemmiHooks.useDelayUnmount(isMounted, 400);

  useEffect(() => {
    setIsMounted(isLoading);
  }, [isLoading]);

  // Don't render anything if we shouldn't mount
  if (!shouldRenderGlobalLoading) return null;

  return createPortal(
    <div
      // className={`${CSSBlock} ${isLogin ? `${CSSBlock}--login-page` : ''}`}
      // style={isMounted ? mountedStyle : unmountedStyle}>
      className={`loading-overlay  ${isLoading}`}
      style={isMounted ? mountedStyle : unmountedStyle}>
      <div className={`${CSSBlock}__logo`}>
        <div className={`${CSSBlock}__loading-indicator`}></div>
        <div className={`${CSSBlock}__title`}>
          <img src={Logo} />
        </div>
        <div className={`${CSSBlock}__subtitle`}>
          <strong>The</strong> Natural Marketplace
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default LoadingGlobal;
